export default __webpack_public_path__ + "static/media/pod-banner-new.9b4ae58c.jpg";